import { engineering } from './engineering';
import { mba } from './mba';
import { creative } from './creative';
import { finance } from './finance';
import { consulting } from './consulting';
import { student } from './student';
import { government } from './government';
import { research } from './research';

export const personas = {
  engineering,
  mba,
  creative,
  finance,
  consulting,
  student,
  government,
  research
};

export default personas;
